// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Tablet to desktop
------------------------- */
@media (min-width: 768px) {
  .modal-dialog.modal-lg {
    width: 760px;
  }
}
@media (min-width: 992px) {
  .modal-dialog.modal-lg {
    width: 900px;
  }
}
@media (min-width: 1440px) {
  /* better handling of large dialog when the font size shifts up at 1440px */
  .modal-dialog.modal-lg {
    width: 1050px;
    max-width: 1050px;
  }
}
.editUserContainer .row {
  display: flex;
}
.us-left-col {
  display: flex;
  flex-direction: column;
}
.us-left-col .card {
  display: flex;
  flex-grow: 1;
}
.us-left-col .card .card-block {
  width: 100%;
}
.us-right-col {
  display: flex;
  flex-direction: column;
}
.us-right-col .user-repositories {
  display: flex;
  flex-grow: 1;
}
.us-right-col .user-repositories .card-block {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
.us-right-col .user-repositories .card-block .scrollable-table {
  flex-grow: 1;
}
.scrollable-table {
  height: 377px;
  overflow: auto;
}
.scrollable-table table {
  border-collapse: unset;
  border-spacing: 0;
}
.scrollable-table table thead {
  position: sticky;
  top: 0;
  z-index: 1;
  background: var(--gw-datatable-header-background);
}
.scrollable-table table thead th {
  background: var(--gw-datatable-header-background);
}
.scrollable-table table thead tr:first-of-type th {
  border-bottom: 1px solid var(--gw-datatable-header-cell-border-color);
}
.scrollable-table table thead tr:nth-of-type(2) th {
  border-top: none;
}
.force-wrap {
  word-wrap: break-word;
}
.siteNavigation .navbar-brand {
  margin-left: 0;
}
.siteNavigation .navbar-brand span {
  font-weight: 400;
}
.fa-1x:HOVER,
.fa-1andAhalfx:HOVER,
.fa-2x:HOVER,
.fa-2andAhalfx:HOVER,
.fa-3x:HOVER,
.fa-4x:HOVER,
.fa-5x:HOVER,
.fa-6x:HOVER {
  text-decoration: none;
}
.index {
  text-align: center;
}
.translate-button {
  background-color: transparent;
  border-color: transparent;
}
.sources .reference a {
  margin-right: 2px;
  background: #cb7b00;
  font-size: 11px;
  text-decoration: none;
  padding: 1px 3px 2px;
  color: #fff;
}
.sources .license a {
  background: #999;
  font-size: 11px;
  text-decoration: none;
  padding: 1px 3px 2px;
  color: #fff;
}
.statistics .form-horizontal {
  margin: 5px;
}
#selected-filters .filtersTitle {
  font-weight: bold;
  color: #004a7c;
}
.filtersSeparator {
  border-right: 1px solid #004a7c;
}
.filter-container {
  border: none;
  color: #004a7c;
  font-size: 12px;
}
.filter-container .filters-label {
  margin-right: 0px;
  font-weight: normal;
}
.filter-container label {
  background: none;
  vertical-align: top;
}
.filter-container label input {
  margin: 4px 0 0;
  width: 12px;
  height: 12px;
}
.searchBoxButtons a {
  margin-left: 5px;
}
.transformSummaryDiv .control-label {
  cursor: default;
}
.paging span {
  cursor: pointer;
}
.margin-right-5 {
  margin-right: 5px !important;
}
.margin-left--5 {
  margin-left: -5px !important;
}
.breakWord {
  word-wrap: break-word;
}
.breadcrumb {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}
.regularTextTitle {
  font-size: 14px !important;
  color: var(--gw-primary-base) !important;
  font-weight: 400 !important;
}
.searchResultInfo {
  font-size: 12px;
  color: #333333;
}
.dropDownToggleDrug {
  cursor: pointer;
}
.dropDownIcon {
  color: var(--gw-primary-base) !important;
  font-size: 14px;
}
.removeUndelineOnHover:HOVER {
  text-decoration: none;
}
.filterIcon {
  color: var(--gw-primary-base) !important;
  font-size: 15px !important;
}
.results-count {
  font-size: 12px !important;
}
#table-results-container {
  overflow-x: hidden;
  overflow-y: hidden;
  position: relative;
}
#table-results-container .shadow-left,
#table-results-container .shadow-right {
  position: absolute;
  width: 24px;
  height: 100%;
  top: 0;
  bottom: 0;
}
#table-results-container .shadow-left {
  left: 0;
}
#table-results-container .shadow-right {
  right: 0;
}
#table-results-container .draggable {
  cursor: hand;
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
}
#table-results-container .draggable.custom_cursor {
  cursor: default !important;
}
#table-results-container .draggable.dragged {
  cursor: grabbing;
  cursor: -moz-grabbing;
  cursor: -webkit-grabbing;
}
#table-results-container .draggable.custom_cursor.dragged {
  cursor: default !important;
}
.linkWithIcon:HOVER i {
  text-decoration: none;
}
.list-group-item .label {
  float: right;
}
.tooltip-inner {
  max-width: 500px !important;
  word-wrap: break-word !important;
}
.fixedCellWidth {
  table-layout: fixed;
  word-wrap: break-word;
}
.blueLink {
  color: #008cba;
}
#selectedRepositories {
  float: left;
  width: 98%;
  padding: 0 1%;
}
#selectLocation {
  margin-bottom: 8px;
}
.form fieldset div label {
  font-weight: 400;
  line-height: 24px;
  height: 24px;
  vertical-align: middle;
  padding-right: 8px;
}
.form fieldset div input {
  margin-left: 0;
}
.form div.checkbox input[type=checkbox] {
  margin-left: 265px;
}
span.error {
  margin: 10px 10px;
  padding: 5px 10px 5px 10px;
  color: #D8000C;
  position: relative;
  top: 3px;
}
form div label.error {
  color: #D8000C;
  text-align: left;
  text-indent: 8px;
}
span.required {
  color: #D8000C;
}
.repositoryFields .row .col-xs-4 span,
.repositoryFields .row .col-sm-4 span,
.repositoryFields .row .col-md-4 span {
  vertical-align: sub;
}
.repositoryFields .selectFile:HOVER {
  text-decoration: none;
}
.ot-unstyled-button {
  display: inline-block;
  padding: 0;
  border: none;
  background: none;
}
.ot-owlim-ctrl .fa-edit,
.ot-owlim-ctrl .ri-pencil-line {
  position: relative;
  top: 2px;
}
/* =================== Loader =========================== */
.ot-loader-home {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
}
.ot-loader-home div {
  font-size: 1.5rem;
  text-align: center;
}
.ot-main-loader object {
  margin: 200px auto;
}
/* NEW LOADER */
.ot-loader-new {
  height: 100%;
  display: flex;
  align-items: center;
}
.ot-loader-new-content {
  margin: auto;
}
.ot-loader-new-content img {
  display: block;
  margin: auto;
}
.ot-loader-new-content .loader-message {
  text-align: center;
  white-space: pre-wrap;
}
a i.fa-sign-out {
  color: white !important;
}
input.ng-invalid.ng-touched,
select.ng-invalid.ng-touched,
textarea.ng-invalid.ng-touched,
form.ng-submitted .ng-invalid {
  border: 1px solid var(--gw-inputtext-invalid-border-color);
}
.nav-tabs .editable-controls {
  margin-left: 1ex;
  margin-right: 1ex;
  padding-top: 6px;
}
.popover {
  max-width: 400px;
}
.navbar {
  font-weight: 600;
}
.navbar .dropdown-menu > li > a,
.navbar .dropdown-menu > li > a:focus {
  font-weight: normal;
}
.ot-splash object {
  display: block;
}
.ot-splash div {
  text-align: center;
  position: relative;
  top: -2.2vw;
  padding-left: 0.5vw;
  font-size: 1.5vw;
}
.ot-splash {
  width: 75vw;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
}
/*# sourceMappingURL=core.css.map */`, "",{"version":3,"sources":["webpack://./packages/legacy-workbench/src/less/core.less","webpack://./core.less"],"names":[],"mappings":"AAAA;2BAC2B;ACG3B;EACE;IACD,YAAA;EDDC;AACF;ACIA;EACE;IACD,YAAA;EDFC;AACF;ACKA;EDHE,2EAA2E;ECK3E;IACD,aAAA;IACA,iBAAA;EDHC;AACF;ACMA;EAGQ,aAAA;ADNR;ACUA;EACI,aAAA;EACA,sBAAA;ADRJ;ACMA;EAKQ,aAAA;EACA,YAAA;ADRR;ACEA;EASY,WAAA;ADRZ;ACaA;EACI,aAAA;EACA,sBAAA;ADXJ;ACSA;EAKQ,aAAA;EACA,YAAA;ADXR;ACKA;EASY,aAAA;EACA,sBAAA;EACA,YAAA;ADXZ;ACAA;EAcgB,YAAA;ADXhB;ACiBA;EACI,aAAA;EACA,cAAA;ADfJ;ACaA;EAKQ,sBAAA;EACA,iBAAA;ADfR;ACSA;EASY,gBAAA;EACA,MAAA;EACA,UAAA;EACA,iDAAA;ADfZ;ACGA;EAegB,iDAAA;ADfhB;ACAA;EAmBgB,qEAAA;ADhBhB;ACHA;EAuBgB,gBAAA;ADjBhB;ACuBA;EACC,qBAAA;ADrBD;ACwBA;EAGE,cAAA;ADxBF;ACqBA;EAMG,gBAAA;ADxBH;AC6BA;;;;;;;;EACC,qBAAA;ADpBD;ACuBA;EACC,kBAAA;ADrBD;ACwBA;EACI,6BAAA;EACA,yBAAA;ADtBJ;ACyBA;EACC,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,WAAA;ADvBD;AC0BA;EACC,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,WAAA;ADxBD;AC2BA;EACC,WAAA;ADzBD;AC4BA;EACC,iBAAA;EACA,cAAA;AD1BD;AC6BA;EACC,+BAAA;AD3BD;AC8BA;EACC,YAAA;EACA,cAAA;EACA,eAAA;AD5BD;AC+BA;EACC,iBAAA;EACA,mBAAA;AD7BD;ACgCA;EACC,gBAAA;EACA,mBAAA;AD9BD;ACiCA;EACC,eAAA;EACA,WAAA;EACA,YAAA;AD/BD;ACkCA;EACC,gBAAA;ADhCD;ACmCA;EACC,eAAA;ADjCD;ACoCA;EACC,eAAA;ADlCD;ACqCA;EACC,4BAAA;ADnCD;ACsCA;EACC,4BAAA;ADpCD;ACuCA;EACC,qBAAA;ADrCD;ACwCA;EACC,2BAAA;EACA,8BAAA;ADtCD;ACyCA;EACC,0BAAA;EACA,wCAAA;EACA,2BAAA;ADvCD;AC0CA;EACC,eAAA;EACA,cAAA;ADxCD;AC2CA;EACC,eAAA;ADzCD;AC4CA;EACC,wCAAA;EACA,eAAA;AD1CD;AC6CA;EACC,qBAAA;AD3CD;ACkDA;EACC,wCAAA;EACA,0BAAA;ADhDD;ACmDA;EACC,0BAAA;ADjDD;ACqDA;EAEC,kBAAA;EACA,kBAAA;EACA,kBAAA;ADpDD;ACgDA;;EAOE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,SAAA;ADnDF;ACwCA;EAeE,OAAA;ADpDF;ACqCA;EAmBE,QAAA;ADrDF;ACkCA;EAuBE,YAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;ADtDF;AC4BA;EA8BE,0BAAA;ADvDF;ACyBA;EAkCE,gBAAA;EACA,qBAAA;EACA,wBAAA;ADxDF;ACoBA;EAwCE,0BAAA;ADzDF;AC6DA;EAEE,qBAAA;AD5DF;ACgEA;EACC,YAAA;AD9DD;ACiEA;EACC,2BAAA;EACA,gCAAA;AD/DD;ACkEA;EACC,mBAAA;EACA,qBAAA;ADhED;ACmEA;EACC,cAAA;ADjED;ACoEA;EACC,WAAA;EACA,UAAA;EACA,aAAA;ADlED;ACqEA;EACC,kBAAA;ADnED;ACsEA;EACC,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;ADpED;ACuEA;EACC,cAAA;ADrED;ACwEA;EACC,kBAAA;ADtED;ACyEA;EACI,iBAAA;EACA,0BAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;ADvEJ;AC0EA;EACI,cAAA;EACH,gBAAA;EACA,gBAAA;ADxED;AC2EA;EACI,cAAA;ADzEJ;AC4EA;;;EAGC,mBAAA;AD1ED;AC6EA;EACC,qBAAA;AD3ED;ACgFA;EACC,qBAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;AD9ED;ACiFA;;EACC,kBAAA;EACA,QAAA;AD9ED;AACA,2DAA2D;ACkF3D;EACI,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,wCAAA;EACA,qCAAA;ADhFJ;ACmFA;EACI,iBAAA;EACA,kBAAA;ADjFJ;ACoFA;EACC,kBAAA;ADlFD;AACA,eAAe;ACqFf;EACC,YAAA;EACA,aAAA;EACA,mBAAA;ADnFD;ACsFA;EACI,YAAA;ADpFJ;ACuFA;EACC,cAAA;EACA,YAAA;ADrFD;ACwFA;EACI,kBAAA;EACA,qBAAA;ADtFJ;AC2FA;EACC,uBAAA;ADzFD;AC8FA;;;;EACC,0DAAA;ADzFD;AC4FA;EACC,gBAAA;EACA,iBAAA;EACA,gBAAA;AD1FD;AC6FA;EACI,gBAAA;AD3FJ;AC8FA;EACI,gBAAA;AD5FJ;AC+FA;;EAEE,mBAAA;AD7FF;ACgGA;EACC,cAAA;AD9FD;ACiGA;EACI,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;AD/FJ;ACkGA;EACI,WAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,wCAAA;EACA,qCAAA;ADhGJ;AACA,mCAAmC","sourcesContent":["/* Tablet to desktop\n------------------------- */\n@media (min-width: 768px) {\n  .modal-dialog.modal-lg {\n    width: 760px;\n  }\n}\n@media (min-width: 992px) {\n  .modal-dialog.modal-lg {\n    width: 900px;\n  }\n}\n@media (min-width: 1440px) {\n  /* better handling of large dialog when the font size shifts up at 1440px */\n  .modal-dialog.modal-lg {\n    width: 1050px;\n    max-width: 1050px;\n  }\n}\n.editUserContainer .row {\n  display: flex;\n}\n.us-left-col {\n  display: flex;\n  flex-direction: column;\n}\n.us-left-col .card {\n  display: flex;\n  flex-grow: 1;\n}\n.us-left-col .card .card-block {\n  width: 100%;\n}\n.us-right-col {\n  display: flex;\n  flex-direction: column;\n}\n.us-right-col .user-repositories {\n  display: flex;\n  flex-grow: 1;\n}\n.us-right-col .user-repositories .card-block {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n}\n.us-right-col .user-repositories .card-block .scrollable-table {\n  flex-grow: 1;\n}\n.scrollable-table {\n  height: 377px;\n  overflow: auto;\n}\n.scrollable-table table {\n  border-collapse: unset;\n  border-spacing: 0;\n}\n.scrollable-table table thead {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: var(--gw-datatable-header-background);\n}\n.scrollable-table table thead th {\n  background: var(--gw-datatable-header-background);\n}\n.scrollable-table table thead tr:first-of-type th {\n  border-bottom: 1px solid var(--gw-datatable-header-cell-border-color);\n}\n.scrollable-table table thead tr:nth-of-type(2) th {\n  border-top: none;\n}\n.force-wrap {\n  word-wrap: break-word;\n}\n.siteNavigation .navbar-brand {\n  margin-left: 0;\n}\n.siteNavigation .navbar-brand span {\n  font-weight: 400;\n}\n.fa-1x:HOVER,\n.fa-1andAhalfx:HOVER,\n.fa-2x:HOVER,\n.fa-2andAhalfx:HOVER,\n.fa-3x:HOVER,\n.fa-4x:HOVER,\n.fa-5x:HOVER,\n.fa-6x:HOVER {\n  text-decoration: none;\n}\n.index {\n  text-align: center;\n}\n.translate-button {\n  background-color: transparent;\n  border-color: transparent;\n}\n.sources .reference a {\n  margin-right: 2px;\n  background: #cb7b00;\n  font-size: 11px;\n  text-decoration: none;\n  padding: 1px 3px 2px;\n  color: #fff;\n}\n.sources .license a {\n  background: #999;\n  font-size: 11px;\n  text-decoration: none;\n  padding: 1px 3px 2px;\n  color: #fff;\n}\n.statistics .form-horizontal {\n  margin: 5px;\n}\n#selected-filters .filtersTitle {\n  font-weight: bold;\n  color: #004a7c;\n}\n.filtersSeparator {\n  border-right: 1px solid #004a7c;\n}\n.filter-container {\n  border: none;\n  color: #004a7c;\n  font-size: 12px;\n}\n.filter-container .filters-label {\n  margin-right: 0px;\n  font-weight: normal;\n}\n.filter-container label {\n  background: none;\n  vertical-align: top;\n}\n.filter-container label input {\n  margin: 4px 0 0;\n  width: 12px;\n  height: 12px;\n}\n.searchBoxButtons a {\n  margin-left: 5px;\n}\n.transformSummaryDiv .control-label {\n  cursor: default;\n}\n.paging span {\n  cursor: pointer;\n}\n.margin-right-5 {\n  margin-right: 5px !important;\n}\n.margin-left--5 {\n  margin-left: -5px !important;\n}\n.breakWord {\n  word-wrap: break-word;\n}\n.breadcrumb {\n  padding-top: 5px !important;\n  padding-bottom: 5px !important;\n}\n.regularTextTitle {\n  font-size: 14px !important;\n  color: var(--gw-primary-base) !important;\n  font-weight: 400 !important;\n}\n.searchResultInfo {\n  font-size: 12px;\n  color: #333333;\n}\n.dropDownToggleDrug {\n  cursor: pointer;\n}\n.dropDownIcon {\n  color: var(--gw-primary-base) !important;\n  font-size: 14px;\n}\n.removeUndelineOnHover:HOVER {\n  text-decoration: none;\n}\n.filterIcon {\n  color: var(--gw-primary-base) !important;\n  font-size: 15px !important;\n}\n.results-count {\n  font-size: 12px !important;\n}\n#table-results-container {\n  overflow-x: hidden;\n  overflow-y: hidden;\n  position: relative;\n}\n#table-results-container .shadow-left,\n#table-results-container .shadow-right {\n  position: absolute;\n  width: 24px;\n  height: 100%;\n  top: 0;\n  bottom: 0;\n}\n#table-results-container .shadow-left {\n  left: 0;\n}\n#table-results-container .shadow-right {\n  right: 0;\n}\n#table-results-container .draggable {\n  cursor: hand;\n  cursor: grab;\n  cursor: -moz-grab;\n  cursor: -webkit-grab;\n}\n#table-results-container .draggable.custom_cursor {\n  cursor: default !important;\n}\n#table-results-container .draggable.dragged {\n  cursor: grabbing;\n  cursor: -moz-grabbing;\n  cursor: -webkit-grabbing;\n}\n#table-results-container .draggable.custom_cursor.dragged {\n  cursor: default !important;\n}\n.linkWithIcon:HOVER i {\n  text-decoration: none;\n}\n.list-group-item .label {\n  float: right;\n}\n.tooltip-inner {\n  max-width: 500px !important;\n  word-wrap: break-word !important;\n}\n.fixedCellWidth {\n  table-layout: fixed;\n  word-wrap: break-word;\n}\n.blueLink {\n  color: #008cba;\n}\n#selectedRepositories {\n  float: left;\n  width: 98%;\n  padding: 0 1%;\n}\n#selectLocation {\n  margin-bottom: 8px;\n}\n.form fieldset div label {\n  font-weight: 400;\n  line-height: 24px;\n  height: 24px;\n  vertical-align: middle;\n  padding-right: 8px;\n}\n.form fieldset div input {\n  margin-left: 0;\n}\n.form div.checkbox input[type=checkbox] {\n  margin-left: 265px;\n}\nspan.error {\n  margin: 10px 10px;\n  padding: 5px 10px 5px 10px;\n  color: #D8000C;\n  position: relative;\n  top: 3px;\n}\nform div label.error {\n  color: #D8000C;\n  text-align: left;\n  text-indent: 8px;\n}\nspan.required {\n  color: #D8000C;\n}\n.repositoryFields .row .col-xs-4 span,\n.repositoryFields .row .col-sm-4 span,\n.repositoryFields .row .col-md-4 span {\n  vertical-align: sub;\n}\n.repositoryFields .selectFile:HOVER {\n  text-decoration: none;\n}\n.ot-unstyled-button {\n  display: inline-block;\n  padding: 0;\n  border: none;\n  background: none;\n}\n.ot-owlim-ctrl .fa-edit,\n.ot-owlim-ctrl .ri-pencil-line {\n  position: relative;\n  top: 2px;\n}\n/* =================== Loader =========================== */\n.ot-loader-home {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n}\n.ot-loader-home div {\n  font-size: 1.5rem;\n  text-align: center;\n}\n.ot-main-loader object {\n  margin: 200px auto;\n}\n/* NEW LOADER */\n.ot-loader-new {\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n.ot-loader-new-content {\n  margin: auto;\n}\n.ot-loader-new-content img {\n  display: block;\n  margin: auto;\n}\n.ot-loader-new-content .loader-message {\n  text-align: center;\n  white-space: pre-wrap;\n}\na i.fa-sign-out {\n  color: white !important;\n}\ninput.ng-invalid.ng-touched,\nselect.ng-invalid.ng-touched,\ntextarea.ng-invalid.ng-touched,\nform.ng-submitted .ng-invalid {\n  border: 1px solid var(--gw-inputtext-invalid-border-color);\n}\n.nav-tabs .editable-controls {\n  margin-left: 1ex;\n  margin-right: 1ex;\n  padding-top: 6px;\n}\n.popover {\n  max-width: 400px;\n}\n.navbar {\n  font-weight: 600;\n}\n.navbar .dropdown-menu > li > a,\n.navbar .dropdown-menu > li > a:focus {\n  font-weight: normal;\n}\n.ot-splash object {\n  display: block;\n}\n.ot-splash div {\n  text-align: center;\n  position: relative;\n  top: -2.2vw;\n  padding-left: 0.5vw;\n  font-size: 1.5vw;\n}\n.ot-splash {\n  width: 75vw;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n}\n/*# sourceMappingURL=core.css.map */","/* Tablet to desktop\n------------------------- */\n\n\n@media (min-width: 768px) {\n  .modal-dialog.modal-lg {\n\twidth: 760px;\n  }\n}\n\n@media (min-width: 992px) {\n  .modal-dialog.modal-lg {\n\twidth: 900px;\n  }\n}\n\n@media (min-width: 1440px) {\n  /* better handling of large dialog when the font size shifts up at 1440px */\n  .modal-dialog.modal-lg {\n\twidth: 1050px;\n\tmax-width: 1050px;\n  }\n}\n\n.editUserContainer {\n\n    .row {\n        display: flex;\n    }\n}\n\n.us-left-col {\n    display: flex;\n    flex-direction: column;\n\n    .card {\n        display: flex;\n        flex-grow: 1;\n\n        .card-block {\n            width: 100%;\n        }\n    }\n}\n\n.us-right-col {\n    display: flex;\n    flex-direction: column;\n\n    .user-repositories {\n        display: flex;\n        flex-grow: 1;\n\n        .card-block {\n            display: flex;\n            flex-direction: column;\n            flex-grow: 1;\n\n            .scrollable-table {\n                flex-grow: 1;\n            }\n        }\n    }\n}\n\n.scrollable-table {\n    height: 377px;\n    overflow: auto;\n\n    table {\n        border-collapse: unset;\n        border-spacing: 0;\n\n        thead {\n            position: sticky;\n            top: 0;\n            z-index: 1;\n            background: var(--gw-datatable-header-background);\n\n            th {\n                background: var(--gw-datatable-header-background);\n            }\n\n            tr:first-of-type th {\n                border-bottom: 1px solid var(--gw-datatable-header-cell-border-color);\n            }\n\n            tr:nth-of-type(2) th {\n                border-top: none;\n            }\n        }\n    }\n}\n\n.force-wrap {\n\tword-wrap: break-word;\n}\n\n.siteNavigation {\n\n\t.navbar-brand {\n\t\tmargin-left: 0;\n\n\t\tspan{\n\t\t\tfont-weight: 400;\n\t\t}\n\t}\n}\n\n.fa-1x:HOVER, .fa-1andAhalfx:HOVER, .fa-2x:HOVER, .fa-2andAhalfx:HOVER,  .fa-3x:HOVER, .fa-4x:HOVER, .fa-5x:HOVER, .fa-6x:HOVER{\n\ttext-decoration: none;\n}\n\n.index{\n\ttext-align: center;\n}\n\n.translate-button {\n    background-color: transparent;\n    border-color: transparent;\n}\n\n.sources .reference a {\n\tmargin-right: 2px;\n\tbackground: #cb7b00;\n\tfont-size: 11px;\n\ttext-decoration: none;\n\tpadding: 1px 3px 2px;\n\tcolor: #fff;\n}\n\n.sources .license a {\n\tbackground: #999;\n\tfont-size: 11px;\n\ttext-decoration: none;\n\tpadding: 1px 3px 2px;\n\tcolor: #fff;\n}\n\n.statistics .form-horizontal{\n\tmargin: 5px;\n}\n\n#selected-filters .filtersTitle{\n\tfont-weight: bold;\n\tcolor: #004a7c;\n}\n\n.filtersSeparator{\n\tborder-right: 1px solid #004a7c;\n}\n\n.filter-container{\n\tborder:none;\n\tcolor: #004a7c;\n\tfont-size: 12px;\n}\n\n.filter-container .filters-label{\n\tmargin-right: 0px;\n\tfont-weight:normal;\n}\n\n.filter-container label{\n\tbackground: none;\n\tvertical-align: top;\n}\n\n.filter-container label input{\n\tmargin: 4px 0 0;\n\twidth: 12px;\n\theight: 12px;\n}\n\n.searchBoxButtons a{\n\tmargin-left: 5px;\n}\n\n.transformSummaryDiv .control-label{\n\tcursor: default;\n}\n\n.paging span {\n\tcursor: pointer;\n}\n\n.margin-right-5{\n\tmargin-right: 5px !important;\n}\n\n.margin-left--5{\n\tmargin-left: -5px !important;\n}\n\n.breakWord{\n\tword-wrap: break-word;\n}\n\n.breadcrumb{\n\tpadding-top: 5px !important;\n\tpadding-bottom: 5px !important;\n}\n\n.regularTextTitle{\n\tfont-size: 14px !important;\n\tcolor: var(--gw-primary-base) !important;\n\tfont-weight: 400 !important;\n}\n\n.searchResultInfo{\n\tfont-size: 12px;\n\tcolor: #333333;\n}\n\n.dropDownToggleDrug {\n\tcursor: pointer;\n}\n\n.dropDownIcon {\n\tcolor: var(--gw-primary-base) !important;\n\tfont-size: 14px;\n}\n\n.removeUndelineOnHover:HOVER{\n\ttext-decoration: none;\n}\n\n\n\n\n\n.filterIcon{\n\tcolor: var(--gw-primary-base) !important;\n\tfont-size: 15px !important;\n}\n\n.results-count{\n\tfont-size: 12px !important;\n}\n\n\n#table-results-container {\n\n\toverflow-x: hidden;\n\toverflow-y: hidden;\n\tposition: relative;\n\n\t.shadow-left, .shadow-right {\n\t\tposition: absolute;\n\t\twidth: 24px;\n\t\theight: 100%;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t}\n\n\t.shadow-left {\n\t\tleft: 0;\n\t}\n\n\t.shadow-right {\n\t\tright: 0;\n\t}\n\n\t.draggable {\n\t\tcursor: hand;\n\t\tcursor: grab;\n\t\tcursor: -moz-grab;\n\t\tcursor: -webkit-grab;\n\t}\n\n\t.draggable.custom_cursor {\n\t\tcursor: default !important;\n\t}\n\n\t.draggable.dragged {\n\t\tcursor: grabbing;\n\t\tcursor: -moz-grabbing;\n\t\tcursor: -webkit-grabbing;\n\t}\n\n\t.draggable.custom_cursor.dragged {\n\t\tcursor: default !important;\n\t}\n}\n\n.linkWithIcon:HOVER {\n\ti{\n\t\ttext-decoration: none;\n\t}\n}\n\n.list-group-item .label {\n\tfloat: right;\n}\n\n.tooltip-inner{\n\tmax-width: 500px !important;\n\tword-wrap: break-word !important;\n}\n\n.fixedCellWidth{\n\ttable-layout: fixed;\n\tword-wrap: break-word;\n}\n\n.blueLink{\n\tcolor: rgb(0, 140, 186);\n}\n\n#selectedRepositories {\n\tfloat: left;\n\twidth: 98%;\n\tpadding: 0 1%;\n}\n\n#selectLocation {\n\tmargin-bottom: 8px;\n}\n\n.form fieldset div label {\n\tfont-weight: 400;\n\tline-height: 24px;\n\theight: 24px;\n\tvertical-align: middle;\n\tpadding-right: 8px;\n}\n\n.form fieldset div input {\n\tmargin-left: 0;\n}\n\n.form div.checkbox input[type=checkbox] {\n\tmargin-left: 265px;\n}\n\nspan.error {\n    margin: 10px 10px;\n    padding:5px 10px 5px 10px;\n    color: #D8000C;\n    position: relative;\n    top: 3px;\n}\n\nform div label.error {\n    color: #D8000C;\n\ttext-align: left;\n\ttext-indent: 8px;\n}\n\nspan.required {\n    color: #D8000C;\n}\n\n.repositoryFields .row .col-xs-4 span,\n.repositoryFields .row .col-sm-4 span,\n.repositoryFields .row .col-md-4 span {\n\tvertical-align: sub;\n}\n\n.repositoryFields .selectFile:HOVER{\n\ttext-decoration: none;\n}\n\n// From here starts the new repositories view styles\n\n.ot-unstyled-button {\n\tdisplay: inline-block;\n\tpadding: 0;\n\tborder: none;\n\tbackground: none;\n}\n\n.ot-owlim-ctrl .fa-edit, .ot-owlim-ctrl .ri-pencil-line {\n\tposition: relative;\n\ttop: 2px;\n}\n\n\n/* =================== Loader =========================== */\n.ot-loader-home {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    -webkit-transform: translate(-50%, -50%);\n    -moz-transform: translate(-50%, -50%);\n}\n\n.ot-loader-home div {\n    font-size: 1.5rem;\n    text-align: center;\n}\n\n.ot-main-loader object {\n\tmargin: 200px auto;\n}\n\n/* NEW LOADER */\n.ot-loader-new {\n\theight: 100%;\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.ot-loader-new-content {\n    margin: auto;\n}\n\n.ot-loader-new-content img {\n\tdisplay: block;\n\tmargin: auto;\n}\n\n.ot-loader-new-content .loader-message {\n    text-align: center;\n    white-space: pre-wrap;\n}\n\n\n\na i.fa-sign-out {\n\tcolor: white !important;\n}\n\n\n\ninput.ng-invalid.ng-touched, select.ng-invalid.ng-touched, textarea.ng-invalid.ng-touched, form.ng-submitted .ng-invalid {\n\tborder: 1px solid var(--gw-inputtext-invalid-border-color);\n}\n\n.nav-tabs .editable-controls {\n\tmargin-left: 1ex;\n\tmargin-right: 1ex;\n\tpadding-top: 6px;\n}\n\n.popover {\n    max-width: 400px;\n}\n\n.navbar {\n    font-weight: 600;\n}\n\n.navbar .dropdown-menu > li > a,\n.navbar .dropdown-menu > li > a:focus {\n  font-weight: normal;\n}\n\n.ot-splash object {\n\tdisplay: block;\n}\n\n.ot-splash div {\n    text-align: center;\n    position: relative;\n    top: -2.2vw;\n    padding-left: 0.5vw;\n    font-size: 1.5vw;\n}\n\n.ot-splash {\n    width: 75vw;\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    -webkit-transform: translate(-50%, -50%);\n    -moz-transform: translate(-50%, -50%);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
